const generics = {
    stage: process.env.REACT_APP_STAGE as 'dev' | 'test' | 'prod'
};

const dev = {
    development: true,
    test: false,
    production: false,
    // analytics: 'http://localhost:3000',
    analytics: 'https://3rl7xe8si9.execute-api.us-east-1.amazonaws.com/test',
    // questions: 'http://localhost:3000',
    questions: 'https://2rlv0s7dpk.execute-api.us-east-1.amazonaws.com/test',
    // api: 'http://localhost:8080',
    api: 'https://test-api.meupasseiovirtual.com',
    googleOAuthRedirectURI: 'https://test-webapp.meupasseiovirtual.com/oauth-callback/google',
    googleMapsAPIKey: 'AIzaSyCx78JeHWTIrkTf4_G6d4s8-TPEoaQOEbs'
};

const test = {
    development: false,
    test: true,
    production: false,
    analytics: 'https://3rl7xe8si9.execute-api.us-east-1.amazonaws.com/test',
    questions: 'https://2rlv0s7dpk.execute-api.us-east-1.amazonaws.com/test',
    api: 'https://test-api.meupasseiovirtual.com',
    googleOAuthRedirectURI: 'https://test-webapp.meupasseiovirtual.com/oauth-callback/google',
    googleMapsAPIKey: 'AIzaSyDuz9ntf47ppBJiuIIryV-yYPLa5Bu10AE'
};

const prod = {
    development: false,
    test: false,
    production: true,
    analytics: 'https://j40ikoy75j.execute-api.us-east-1.amazonaws.com/prod',
    questions: 'https://383ocfd1w9.execute-api.us-east-1.amazonaws.com/prod',
    api: 'https://api.meupasseiovirtual.com',
    googleOAuthRedirectURI: 'https://webapp.meupasseiovirtual.com/oauth-callback/google',
    googleMapsAPIKey: 'AIzaSyDuz9ntf47ppBJiuIIryV-yYPLa5Bu10AE'
};

const config = { ...generics, ...(generics.stage === 'prod' ? prod : generics.stage === 'test' ? test : dev) };

export default config;
